export default function filterByCountry(items, locale) {
    if ( items.length > 0 ) {
        return items.filter((x, i) => {
            const localeSplit = locale.split('-')
            const langCode = localeSplit[1]
            const check = x.node.countryAvailability.indexOf(langCode)
            return check >= 0 ? x : null
        })
    } else {
        return []
    }
}
